import { useEffect, useState } from "react";
import TanstackDatagrid from "components/ReusableComponents/TanstackDatagrid/TanstackDatagrid";
import { Box, Button } from "@mui/material";
import axios from "axios";
import { GlobalState } from "context/GlobalContext";
import { parseErrorMessage } from "utils/ErrorFunctions/parseErrorMessage";
import FileSaver from "file-saver";
import { AddRounded, DownloadRounded } from "@mui/icons-material";
import CreateOrUpdateBlockModal from "./CreateOrUpdateFabricModal/CreateOrUpdateFabricModal";
import { blockMasterColumnsObj } from "./data";
import { AuthState } from "context/AuthContext";
import { createdByColumns } from "data/globalData";
import moment from "moment";

const StyleBlockMaster = () => {
	const { setLoadingOpen, snackBar, setSnackBarOpen, setSnackBar } = GlobalState();
	const { user } = AuthState();
	const [data, setData] = useState([]);
	const [rowCount, setRowCount] = useState(0);
	const [filterObj, setFilterObj] = useState({});
	const [modal, setModal] = useState(false);
	const [modalMode, setModalMode] = useState(false);
	const [selectedRow, setSelectedRow] = useState(false);

	const tableColumns = [...Object.values(blockMasterColumnsObj), ...createdByColumns].map((row) => ({
		...row,
		align: "center",
		headerAlign: "center",
	}));

	const fetchData = async (limit, offset, filterObj) => {
		const res = await axios.post(`/api/catalogue/block_master/get`, {
			limit,
			offset,
			filter: filterObj,
		});
		return res.data.result;
	};

	const handleCreateClick = () => {
		setModal(true);
		setModalMode("create");
	};

	const handleBlockRowSelect = (row) => {
		setModal(true);
		setModalMode("update");
		setSelectedRow(row);
	};

	const handleCreateorEditSave = async (apiBody) => {
		setLoadingOpen(true);
		try {
			if (modalMode === "create") {
				const res = await axios.post("/api/catalogue/block_master/create", apiBody);
				setData([res.data.result, ...data]);
				setModal(false);
			} else {
				await axios.put(`/api/catalogue/block_master/update/${apiBody?.block_code}`, apiBody).then((res) => {
					setData((prev) =>
						prev.map((row) => {
							if (row.block_code === apiBody.block_code) return { ...apiBody, last_updated_by: user.email };
							return row;
						}),
					);
					setModal(false);
				});
			}
			setSnackBarOpen(true);
			setSnackBar({
				...snackBar,
				severity: "success",
				message: `Block ${modalMode === "create" ? "Created" : "Updated"} Successfully`,
			});
		} catch (error) {
			setSnackBarOpen(true);
			setSnackBar({ ...snackBar, severity: "error", message: parseErrorMessage(error) });
		} finally {
			setLoadingOpen(false);
		}
	};

	const handleDownloadClick = async () => {
		setLoadingOpen(true);
		try {
			await axios({
				url: `/api/catalogue/block_master/download_block_master`,
				method: "POST",
				responseType: "blob",
				data: { filter: filterObj },
			}).then((res) => {
				const url = URL.createObjectURL(res.data);
				FileSaver.saveAs(url, `BlockMaster_${moment().format("DD-MMM-yy : HH:SS")}.xlsx`);
				setLoadingOpen(false);
			});
		} catch (error) {
			setSnackBarOpen(true);
			setSnackBar({ ...snackBar, message: parseErrorMessage(error) });
			setLoadingOpen(false);
		}
	};

	return (
		<Box sx={{ height: "calc(100vh - 135px)", p: 1 }} boxSizing="border-box">
			<TanstackDatagrid
				columns={tableColumns}
				pageData={data}
				setPageData={setData}
				rowCount={rowCount}
				setRowCount={setRowCount}
				filterObj={filterObj}
				setFilterObj={setFilterObj}
				isLoading={false}
				emptyMessage="No matching records"
				handleRowClick={({ row }) => handleBlockRowSelect(row)}
				getServerSideData={fetchData}
				getRowId={(row) => row[blockMasterColumnsObj.block_code.key]}>
				<Box sx={{ display: "flex", alignItems: "center", p: 1, justifyContent: "space-between" }}>
					<Button variant="contained" size="medium" onClick={handleCreateClick} startIcon={<AddRounded />}>
						Create
					</Button>
					<Button variant="contained" size="small" onClick={handleDownloadClick} startIcon={<DownloadRounded />}>
						Export
					</Button>
				</Box>
			</TanstackDatagrid>
			{modal && (
				<CreateOrUpdateBlockModal
					open={modal}
					setOpen={setModal}
					mode={modalMode}
					handleSaveFunction={handleCreateorEditSave}
					selectedRow={selectedRow}
					setSelectedRow={setSelectedRow}
				/>
			)}
		</Box>
	);
};

export default StyleBlockMaster;
